import PropTypes from 'prop-types';

export const BEST_CARS_CONTENT_PATH = 'research/car-reviews/best-cars/index';

export const BEST_CARS_LOGO_SRC = '/img/top-rated/top-rated-white-logo.svg';

export const BEST_CARS_BREADCRUMBS = [
  { title: 'Home', href: '/' },
  { title: 'Best Cars', href: '/best-cars/' },
];

export const HERO_PHOTO_SIZE = {
  MOBILE: 500,
  DESKTOP: 1600,
};

export const VIDEO_CARD_THUMBNAIL_SIZE = 500;
export const VIDEO_CARD_THUMBNAIL_SIZE_WIRED = 717;

// 4 lines of 16px text
export const TRUNCATED_HTML_HEIGHT = 85;

export const SECTION_RELATED_CONTENT = {
  ASPECT_RATIO: '16:9',
  ITEM_CLASS_NAME: 'mt-1',
  PHOTO_SIZE: 175,
  COLUMN_NUMBER: {
    MOBILE: 2,
    DESKTOP: 4,
  },
  MAX_CONTENT_LENGTH: {
    MOBILE: 2,
    DESKTOP: 4,
  },
};

export const RELATED_CONTENT_CONFIG = {
  ASPECT_RATIO: '16:9',
  ITEM_CLASS_NAME: 'mt-2',
  PHOTO_SIZE: 300,
  COLUMN_NUMBER: {
    MOBILE: 2,
    DESKTOP: 3,
  },
  MAX_CONTENT_LENGTH: {
    MOBILE: 4,
    DESKTOP: 6,
  },
};

export const BUTTONS_DEFAULT_TITLE = {
  PRIMARY: 'Pricing & Reviews',
  SECONDARY: 'See Rankings',
};

export const LinkDataPropType = PropTypes.shape({
  title: PropTypes.string,
  url: PropTypes.string,
  nofollow: PropTypes.bool,
  blank: PropTypes.bool,
});
